import dynamic from 'next/dynamic';
import LoaderPage from '@/reactPages/LoaderPage/LoaderPage';

export const MainPage = dynamic(() => import('./MainPage'), {
  ssr: false,
  loading: () => <LoaderPage/>,
});
